define('viewmodels/configuration/UserGroup',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'durandal/system', 'services/logger', 'viewmodels/GeneralSettings'], function (ko, router, appsecurity, navigation, app, system, logger, ObjGeneralSettings) {

    var YrViewModel = {
        activate: activate,
        attached: attached,
        appsecurity: appsecurity,
        CreateNewGroup: CreateNewGroup,
        ObjGeneralSettings: ObjGeneralSettings,
        popUpTitle: ko.observable(),
        GroupName: ko.observable(),
        GroupDesc: ko.observable(),
        EditGroupName: ko.observable(),
        EditGroupDesc: ko.observable(),
        DeleteGroupId: ko.observable(),
        addPopUpCss: ko.observable(),
        BUTitle: ko.observable('Business Unit'),
        UserMappingList: ko.observableArray([]),
        BUList: ko.observableArray([]),
        BUListDup: ko.observableArray([]),
        ATList: ko.observableArray([]),
        BUATMappingsList: ko.observableArray([]),
        Copyconfigurations: ko.observable(),
        UserGroupList: ko.observableArray(),
        editGroupID: ko.observable(),
        YearofAssessmentList: ko.observableArray(),
        ValidYearDetails: ko.observableArray(),
        YearDetails: ko.observableArray(),
        PopUpOpenId: ko.observable(),
        AllYearDetails: ko.observableArray([]),
        CurrentYearofAssessment: ko.observable(),
        SaveNewGroup: SaveNewGroup,
        saveEditUserGroupPopup: saveEditUserGroupPopup,
        OpenUserDetailsPopup: OpenUserDetailsPopup,
        OpenBUDetailsPopup: OpenBUDetailsPopup,
        SelectAllUsers: SelectAllUsers,
        selectedBuAT: selectedBuAT,
        selectedBU: selectedBU,
        SelectAllBUs: SelectAllBUs,
        SaveUserGroupMapping: SaveUserGroupMapping,
        SaveBUATMappings: SaveBUATMappings,
        editGroupDetails: editGroupDetails,
        ControlsAccess: ko.observable(true),
        Savedisabled: ko.observable(true),
        writeAccess: ko.observable(),
        showDeleteGroupPopup: showDeleteGroupPopup,
        confirmDeleteGroup: confirmDeleteGroup
    };
    return YrViewModel;

    function activate() {
        try {
            
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: activate() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }

    function attached() {
        try {
            getUserGroupData();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }

    //-------------------------------------------------Function that opens the create group popup starts here----------------------------------------------------------------
    function CreateNewGroup(data, event) {
        try {
            YrViewModel.popUpTitle("Create New Group");
            YrViewModel.addPopUpCss(true);
            YrViewModel.GroupName('');
            YrViewModel.GroupDesc('');
            $('#CreateNewGroupPopup').modal('show');
            $('#valcreateerror').hide();
            $('#valcreateerror').text('');

        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in CreateNewGroupPopup() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }

    function showDeleteGroupPopup(data, event) {
        try {
            YrViewModel.DeleteGroupId(data.Id());
            YrViewModel.popUpTitle("Confirm Delete");
            YrViewModel.addPopUpCss(true);
            $('#deleteGroupDetails').modal('show');
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in showDeleteGroupPopup() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }

    function confirmDeleteGroup(data, event) {
        try {
            $('#deleteGroupDetails').modal('hide');
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Calculation/DeleteUserGroup",
                headers: headers,
                type: "POST",
                data: { _Id: parseInt(data.DeleteGroupId()) }
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call from CreateNewUserGroup() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult > 0) {
                    logger.logSuccess('User Group has been deleted successfully.', 'Success', system.getModuleId(YrViewModel), true);
                    getUserGroupData();
                }
                else {

                    logger.logError(jsonResult + " - " + 'An error occurred while deleting group. Please contact your Administrator.', 'Error', system.getModuleId(YrViewModel), true);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from confirmDeleteGroup() method in ResponsibilityGroup.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();

                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in CreateNewUserGroup() method in ResponsibilityGroup.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail from confirmDeleteGroup() method in ResponsibilityGroup.js';
                logger.logMessage(msg);
            }
        }
    }
    function editGroupDetails(data, event) {
        try {
            YrViewModel.editGroupID(data.Id());
            YrViewModel.EditGroupName(data.GroupName());
            YrViewModel.EditGroupDesc(data.GroupDesc());
            $('#valErrorYSEdit').hide();
            YrViewModel.popUpTitle("Edit User Group Details");
            $('#editGroupDetails').modal("show")
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: editGroupDetails() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }

    }
    function getUserGroupData() {
        try {
            $.ajax({
                url: "/api/Calculation/GetUserGroupDetails",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: getUserGroupData() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult.length == 0)
                    logger.logError('No records present.', 'Warning', system.getModuleId(YrViewModel), true);
                var MappedGroupDetails = $.map(jsonResult, function (result) {
                    return new UserGroupModel(result);
                });


                tableObj = $('#tblReportDetails').DataTable();
                tableObj.destroy();
                $('#tblReportDetails tbody tr').remove();
                QuestionTableObj = undefined;
                YrViewModel.UserGroupList([]);
                YrViewModel.UserGroupList(MappedGroupDetails)
                QuestionTableObj = $('#tblReportDetails').DataTable({
                    "order": [],
                    "aaSorting": [],
                    "aoColumnDefs": [
                        {
                            "aTargets": [1],
                            "bVisible": true,
                            "bSortable": false

                        }, {
                            "aTargets": [2],
                            "bVisible": true,
                            "bSortable": true

                        }, {
                            "aTargets": [3],
                            "bVisible": true,
                            "bSortable": false

                        }
                    ],
                    "fnRowCallback": function (nRow, aData) {
                        if (aData[0] == YrViewModel.CurrentYear) {
                            $('td', nRow).css('background-color', '#CCE5FF');
                        }
                    }

                });

                $('#tblReportDetails').DataTable().draw(false);

                if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null)
                {
                    logger.logError(jsonResult[0].Incident_Description + " - " + 'Some Error Occured while fetching User Group details. Please contact the Administrator', 'Error', system.getModuleId(YrViewModel), true);
                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from getUserGroupData() method in ResponsibilityGroup.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();

                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getUserGroupData() method in ResponsibilityGroup.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail from getUserGroupData() method in ResponsibilityGroup.js';
                logger.logMessage(msg);
            }
        }

    }

    function getUserGroupBUAssignments() {
        try {
            $.ajax({
                url: "/api/Calculation/GetUserGroupBUAssignments",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { GroupId: parseInt(YrViewModel.PopUpOpenId()) }
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);

            function ajaxSuccess(jsonResult, status) {
                try {
                    if ($.fn.dataTable.isDataTable('#BUATMappingTable')) {
                        $('#BUATMappingTable').DataTable({ retrieve: true }).destroy();
                        $('#BUATMappingTable tbody tr').remove();
                    }
                    if (jsonResult != null) {
                        YrViewModel.BUList([]);
                        YrViewModel.ATList([]);
                        if (jsonResult.BUListModelObj != null) {

                            var MappedBUDetails = $.map(jsonResult.BUListModelObj, function (result) {
                                return new BUListModel(result);
                            })
                            YrViewModel.BUList(MappedBUDetails);
                            YrViewModel.BUListDup(MappedBUDetails);
                        }
                        if (jsonResult.ATListModelObj != null) {
                            var MappedATDetails = $.map(jsonResult.ATListModelObj, function (result) {
                                return new ATListModel(result);
                            })
                            YrViewModel.ATList(MappedATDetails);
                            $('#BUATMappingTable').DataTable();
                        }

                    }

                    if (jsonResult.Incident_Description != null)
                    {
                        logger.logError(jsonResult.Incident_Description + " - " + 'Some Error Occured while fetching Business Units. Please contact the Administrator', 'Error', system.getModuleId(YrViewModel), true);
                    }


                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from getBUAssignments() method in ResponsibilityGroup.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getBUAssignments() method in ResponsibilityGroup.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail from getBUAssignments() method in ResponsibilityGroup.js';
                    logger.logMessage(msg);
                }
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail from getBUAssignments() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }
    //-----------------------------------------------------------------Function that is invoked on click of save for the create new group starts here---------------------------------
    function SaveNewGroup(data, event) {
        try {
            $('#valcreateerror').hide();
            data.GroupName();
            data.GroupDesc();
            if (data.GroupName() == null || data.GroupName == 'undefined' || data.GroupName() == '') {
                $('#valcreateerror').text('Please enter all the required fields');
                $('#valcreateerror').show()
                return;
            }

            CreateNewUserGroup(data.GroupName(), data.GroupDesc());
            $('#CreateNewGroupPopup').modal('hide');
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveNewGroup() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }
    //-----------------------------------------------------------------Function that is invoked on click of save for the create new group endss here--------------------------------


    function saveEditUserGroupPopup(data, event) {
        try {
            var duplicate = 0;
            var Id = data.editGroupID();
            var group_name = data.EditGroupName();
            var group_desc = data.EditGroupDesc();
            if (group_name == null || group_name == 'undefined' || group_name == '') {
                $('#valErrorYSEdit').text('Please enter all the required fields');
                $('#valErrorYSEdit').show();
                return;
            }
            for (i = 0; i < YrViewModel.UserGroupList().length; i++) {
                if (YrViewModel.UserGroupList()[i].Id() == Id && YrViewModel.UserGroupList()[i].GroupName() == group_name && YrViewModel.UserGroupList()[i].GroupDesc() == group_desc) {
                    duplicate++;
                    $('#valErrorYSEdit').text("No Changes Made.");
                    $('#valErrorYSEdit').show();
                }
            }
            if (duplicate == 0) {
                SaveEditGroupDetails(Id, group_name, group_desc);

                $('#valErrorYSEdit').hide();
                $('#editGroupDetails').modal('hide');
                $('body').removeClass('modal-open');
                $('.modal-backdrop').remove();
            }


        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: saveEditUserGroupPopup() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }



    //---------------------------------------------------------------Function that is invoked on click od save of the change assessmentprofile ends here---------------------------------------


    function CreateNewUserGroup(GroupName, GroupDesc) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Calculation/CreateNewUserGroup",
                headers: headers,
                type: "POST",
                data: { _Group_name: GroupName, _Group_desc: GroupDesc }
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call from CreateNewUserGroup() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                var code = jsonResult.slice(0, 2);
                var msg = jsonResult.slice(3, 14);
                if (jsonResult == '1') {
                    logger.logSuccess('User Group has been created successfully.', 'Success', system.getModuleId(YrViewModel), true);
                    getUserGroupData();
                }
                else if (code == '-1') {
                    logger.logWarning('User Group name already exists.', 'Warning', system.getModuleId(YrViewModel), true);
                    $('#valfactorerror').text('User Group Name Already Exists.');
                    $('#valfactorerror').show();
                }
                else
                    logger.logError(jsonResult + " - " + 'An error occurred while creating group. Please contact your Administrator.', 'Error', system.getModuleId(YrViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from CreateNewUserGroup() method in ResponsibilityGroup.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();

                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in CreateNewUserGroup() method in ResponsibilityGroup.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail from CreateNewUserGroup() method in ResponsibilityGroup.js';
                logger.logMessage(msg);
            }
        }
    }
    //------------------------------Function that creates new profile of assessment without copying configurations ends here-----------------



    function SaveEditGroupDetails(id, group_name, group_desc) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Calculation/SaveEditGroupDetails",
                type: "POST",
                headers: headers,
                data: { _Group_name: group_name, _Group_desc: group_desc, _Id: id }
            })
                .success(function (jsonResult, error) {
                    if (jsonResult == '1') {
                        logger.logSuccess('Group Details Have Been Edited Successfully.', 'Success', system.getModuleId(YrViewModel), true);
                        getUserGroupData();
                    }
                    else
                        logger.logError(jsonResult + " - " + 'An error occurred while editing group details. Please contact your Administrator.', 'Error', system.getModuleId(YrViewModel), true);

                })
                .fail(function (error, status) {
                    logger.logError('An error has occurred while editing group details. Please contact the Application Administrator.', 'Error', system.getModuleId(YrViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in SaveEditGroupDetails() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }

    //------------------------------Function that gets the userdetails starts here--------------------------------------------------------------------------------
    function GetUserProfileMappings() {
        try {
            return $.ajax({
                url: "/api/Calculation/GetAllUserGroupMapping",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { Id: parseInt(YrViewModel.PopUpOpenId()) }
            })
                .success(function (jsonResult, error) {
                    YrViewModel.UserMappingList([]);
                    tableObj = $('#UserProfileMappingTable').DataTable();

                    tableObj.destroy();
                    $('#UserProfileMappingTable tbody tr').remove();

                    var MappeduserProfileList = $.map(jsonResult, function (result) {
                        return new UserProfileMappingModel(result);
                    });
                    YrViewModel.UserMappingList(MappeduserProfileList);
                    $('#UserProfileMappingTable').dataTable({
                        "order": [],
                        "aaSorting": [],
                        "aoColumnDefs": [
                            {
                                "aTargets": [0],
                                "bVisible": true,
                                "bSortable": false
                            }]
                    });

                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null)
                    {
                        logger.logError(jsonResult[0].Incident_Description + " - " + 'An error has occurred while fetching the User Details. Please contact the Administrator', 'Error', system.getModuleId(YrViewModel), true);
                    }
                })
                .fail(function (error, status) {
                    logger.logError('An error has occurred while fetching the User Details.', 'Error', system.getModuleId(YrViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetUserProfileMappings() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }
    //------------------------------Function that gets UserDetails ends here--------------------------------------------------------------------------------------
    //------------------------------Function That gets called on click of the manageuseractions action button starts here-------------------------------------------------------------------
    function OpenUserDetailsPopup(data, event) {
        try {
            YrViewModel.PopUpOpenId(parseInt(data.Id()));

            GetUserProfileMappings().then(function () {
                YrViewModel.popUpTitle("Map Users");
                YrViewModel.addPopUpCss(true);
                $('#UserProfileMapping').modal('show');
                $("#selectall").prop("checked", false);
            })


        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in OpenUserDetailsPopup() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }
    //------------------------------Function that gets called on click of the manageuseractions action button ends here---------------------------------------------------------------------


    //------------------------------BU-Assessment Types PopUP Code Starts here-------------------------

    function OpenBUDetailsPopup(data, event) {
        try {
            YrViewModel.PopUpOpenId(parseInt(data.Id()));
            getUserGroupBUAssignments();
            YrViewModel.popUpTitle(YrViewModel.BUTitle() + " - Assessment Type Mapping");
            YrViewModel.addPopUpCss(true);
            $('#BUATMapping').modal('show');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OpenBUDetailsPopup() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    //-----------------------------------------------------------------------BU-Assessment Types PopUP Code Ends here-------------------------



    //-----------------------------------------------------------------------Logic to Fetch User Details and List of All Roles Starts Here----------------------------------------------

    //-----------------------------------------------------------------------Function to save the user profile mapping starts here----------------------
    function SaveUserGroupMapping(data, event) {
        try {

            var userList = JSON.stringify($.map(data.UserMappingList(), function (result) {
                if (result.IsMapped() == true) {
                    return { _User_Id: result.UserId() };
                }
            }));
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            return $.ajax({
                url: "/api/Calculation/SaveUserGroupMappings?GroupId=" + YrViewModel.PopUpOpenId(),
                type: "POST",
                headers: headers,
                contentType: 'application/json',
                dataType: 'json',
                data: userList
            })
                .success(function (jsonResult, error) {
                    if (jsonResult != null || jsonResult === undefined) {
                        if (isNaN(jsonResult)) {
                            logger.logError(jsonResult + " - " + 'An error has occurred while saving the User Details.', 'Error', system.getModuleId(YrViewModel), true);
                        }
                        else
                        {
                            YrViewModel.UserMappingList([]);
                            
                            var MappeduserProfileList = $.map(parseInt(jsonResult), function (result) {
                                return new UserProfileMappingModel(result);
                            });
                            YrViewModel.UserMappingList(MappeduserProfileList);
                            $('#UserProfileMapping').modal('hide');

                            logger.logSuccess('Users has been assigned successfully to the Group.', 'Success', system.getModuleId(YrViewModel), true);
                        }
                    }

                })
                .fail(function (error, status) {
                    logger.logError('An error has occurred while saving the User Details.', 'Error', system.getModuleId(YrViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in SaveUserGroupMapping() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }
    //-----------------------------------------------------------------------Function to save the user profile mapping ends here-------------------------


    //-----------------------------------------------------------------------Functions related to checkboxes starts here----------------------------------
    function SelectAllUsers(data, event) {
        try {
            if (event.currentTarget.checked) {
                for (var i = 0; i < YrViewModel.UserMappingList().length; i++) {
                    YrViewModel.UserMappingList()[i].IsMapped(true);
                }

            }
            else {
                for (var i = 0; i < YrViewModel.UserMappingList().length; i++) {
                    YrViewModel.UserMappingList()[i].IsMapped(false);
                }
            }
            var rows = $("#UserProfileMappingTable").dataTable().fnGetNodes();
            var cells = [];
            for (var i = 0; i < rows.length; i++) {
                if (event.currentTarget.checked == true)
                    $(rows[i]).find("td:eq(0)").find('input').prop("checked", true);
                else
                    $(rows[i]).find("td:eq(0)").find('input').prop("checked", false);
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in SelectAllUsers() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }
    function selectedBuAT(data, event) {
        try {

            var selectedvalue = "";
            var columnId = "",
                splitColumnId = "";
            if (event != undefined) {
                columnId = event.currentTarget.id;
            }
            if (columnId != undefined && columnId != "") {
                splitColumnId = columnId.split("_");
            }
            var businessUnitId = "",
                assessmentTypeId = "";
            if (splitColumnId != undefined && splitColumnId.length > 1) {
                businessUnitId = splitColumnId[0];
                assessmentTypeId = splitColumnId[1];
            }

            for (var i = 0; i < YrViewModel.BUList().length; i++) {
                if (YrViewModel.BUList()[i].BU_ID() == businessUnitId) {
                    var temp = 0;
                    for (var h = 0; h < YrViewModel.BUList()[i].BUATList().length; h++) {
                        if (YrViewModel.BUList()[i].BUATList()[h].AT_ID() == assessmentTypeId) {
                            if (YrViewModel.BUList()[i].BUATList()[h].IsApplicableAT()) {

                                YrViewModel.BUList()[i].BUATList()[h].IsApplicableAT(false);
                            }
                            else {
                                YrViewModel.BUList()[i].BUATList()[h].IsApplicableAT(true);
                            }
                        }
                    }

                    for (var h = 0; h < YrViewModel.BUList()[i].BUATList().length; h++) {
                        if (YrViewModel.BUList()[i].BUATList()[h].IsApplicableAT() == false) {
                            temp = 0;
                        }
                        else {
                            temp = 1;
                            break;
                        }
                    }

                    YrViewModel.BUList()[i].isChecked = (temp>0) ? true : false;
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in selectedBuAT() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }

    function selectedBU(data, event) {
        try {
            var businessUnitId = "";
            if (event != undefined) {
                businessUnitId = event.currentTarget.id;
            }

            for (var i = 0; i < YrViewModel.BUList().length; i++) {
                if (YrViewModel.BUList()[i].BU_ID() == businessUnitId) {

                    if (YrViewModel.BUList()[i].IsChecked()) {

                        YrViewModel.BUList()[i].IsChecked(false);
                        for (j = 0; j < YrViewModel.BUList()[i].BUATList().length; j++) {
                            YrViewModel.BUList()[i].BUATList()[j].IsApplicableAT(false);
                        }
                    }
                    else {
                        YrViewModel.BUList()[i].IsChecked(true);
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in selectedBU() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }

    function SelectAllBUs(data, event) {
        try {
            if (event.currentTarget.checked) {
                $('#selectallBUs').prop('checked', true);
                for (var i = 0; i < YrViewModel.BUList().length; i++) {
                    YrViewModel.BUList()[i].IsChecked(true);
                }
            }
            else {
                $('#selectallBUs').prop('checked', false);
                for (var i = 0; i < YrViewModel.BUList().length; i++) {
                    YrViewModel.BUList()[i].IsChecked(false);
                    for (j = 0; j < YrViewModel.BUList()[i].BUATList().length; j++) {
                        YrViewModel.BUList()[i].BUATList()[j].IsApplicableAT(false);
                    }
                }
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in selectedBU() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }

    }
    //-----------------------------------------------------------------------Functions related to checkboxes ends here----------------------------------------------------


    //-----------------------------------------------------------------------Function to save the Business Unit - Assessment Type mappings starts here----------------------
    function SaveBUATMappings(data, event) {
        try {
            for (var i = 0; i < data.BUList().length; i++) {
                var temp = -1;
                if (data.BUList()[i].IsChecked()) {
                    for (var j = 0; j < data.BUList()[i].BUATList().length; j++) {
                        if (data.BUList()[i].BUATList()[j].IsApplicableAT() == false && temp != 0) {

                        }
                        else {
                            temp = 0;
                        }
                    }
                    if (temp != 0) {
                        logger.logError('Select atleast one Assessment Type for selected ' + YrViewModel.BUTitle()  + '(s).', 'Error', system.getModuleId(YrViewModel), true);
                        return;
                    }
                }
            }
            YrViewModel.BUATMappingsList([]);
            for (var i = 0; i < data.BUList().length; i++) {

                for (var j = 0; j < data.BUList()[i].BUATList().length; j++) {

                    var MappedList = new BUATMappingsModel();
                    MappedList.BuId = data.BUList()[i].BU_ID();
                    MappedList.ATId = data.BUList()[i].BUATList()[j].AT_ID();

                    MappedList.AT_Applicability = (data.BUList()[i].BUATList()[j].IsApplicableAT() == true) ? 'Y' : 'N';

                    MappedList.BU_Applicability = (data.BUList()[i].IsChecked() == true) ? 'Y' : 'N';

                    YrViewModel.BUATMappingsList.push(MappedList);

                }
            }
            var mappingsList = JSON.stringify($.map(data.BUATMappingsList(), function (result) {
                return { BUId: result.BuId, ATId: result.ATId, AT_Applicability: result.AT_Applicability, BU_Applicability: result.BU_Applicability }
            }));


            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            return $.ajax({
                url: "/api/Calculation/SaveBUATMappings?GroupId=" + data.PopUpOpenId(),
                type: "POST",
                headers: headers,
                contentType: 'application/json',
                dataType: 'json',
                data: mappingsList
            })
                .success(function (jsonResult, error) {
                    $('#BUATMapping').modal('hide');
                        if (jsonResult != null || jsonResult === undefined) {
                            if (isNaN(jsonResult))
                                logger.logError(jsonResult + " - " + 'An error has occurred while saving the User Details.', 'Error', system.getModuleId(YrViewModel), true);
                            else
                                logger.logSuccess(YrViewModel.BUTitle() + ' and Assessment Type Mappings have been updated successfully.', 'Success', system.getModuleId(YrViewModel), true);
                        }
                })
                .fail(function (error, status) {
                   logger.logError('An error has occurred while saving the User Details.', 'Error', system.getModuleId(YrViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in SaveBUATMappings() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }
    //-----------------------------------------------------------------------Function to save the Business Unit - Assessment Type mappings ends here-------------------------


    //Model to Store the Profileofassessmentdetails
    function UserGroupModel(item) {
        try {
            var self = this;
            self.ConfigurationFreezeFlag = ko.observable('true');
            self.Id = ko.observable($('<div/>').html(item._Id).text());
            self.GroupName = ko.observable($('<div/>').html(item._Group_name).text());
            self.GroupDesc = ko.observable($('<div/>').html(item._Group_desc).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: UserGroupModel() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }

    //Model to store the mapping between user and profile
    function UserProfileMappingModel(item) {
        try {
            var self = this;
            self.UserId = ko.observable(item.UserId);
            self.UserName = ko.observable($('<div/>').html(item.UserName).text());
            self.PrimaryRoleName = ko.observable($('<div/>').html(item.PrimaryRoleName).text());
            self.IsMapped = ko.observable(item.IsActive);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: UserProfileMappingModel() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }

    function BUListModel(item) {
        try {
            var self = this;
            self.BU_ID = ko.observable(item.BuId);
            self.BU_Name = ko.observable(item.BuName);
            self.IsChecked = ko.observable(item.BUApplicability);
            var MappedList = $.map(item.ATListModelObj, function (result) {
                return new ATListModel(result);
            });
            self.BUATList = ko.observableArray(MappedList);


        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BUListModel() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }

    function ATListModel(item) {
        try {
            var self = this;
            self.AT_ID = ko.observable(item.ATId);
            self.AT_Name = ko.observable(item.ATName);
            self.IsApplicableAT = ko.observable(item.IsApplicableAT);
            self.BU_AT_ID = ko.observable(item.BuATId);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ATListModel() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }
    function BUATMappingsModel(item) {
        try {
            var self = this;
            self.BuId = ko.observable(item.BU_ID);
            seld.AtId = ko.observable(item.AT_ID);
            self.AT_Applicability = ko.observable(item.IsApplicableAT);
            self.BU_Applicability = ko.observable(item.IsChecked);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BUATMappingsModel() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }

    //------------------------------------------------------------------------Model Definition Ends Here-----------------------------------------------------------------------------

});
